module.exports = __webpack_public_path__ + "img/服务案例_动力_白2.b8dd6e8b.svg";